'use client';

import { useEffect, useState } from 'react';

interface ServicesHeroProps {
  language: 'en' | 'es';
}

const ServicesHero = ({ language }: ServicesHeroProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const content = {
    en: {
      headline: 'What We Do',
    },
    es: {
      headline: 'Lo Que Hacemos',
    },
  };

  return (
    <section className="pt-32 pb-12 px-6">
      <div className="max-w-screen-xl mx-auto text-center">
        <h1
          className={`text-5xl md:text-6xl font-bold tracking-tight text-foreground ${
            isVisible ? 'animate-fadeInUp' : 'opacity-0'
          }`}
        >
          {content[language].headline}
        </h1>
      </div>
    </section>
  );
};

export default ServicesHero;